/* tslint:disable */
/* eslint-disable */
/**
 * WeWalk API V2.0
 * Backend service for WeWALK Mobile Applications, written in **TypeScript** and runs on **NodeJS**. Using **MongoDB** for database, **mongoose** for ORM, **Redis Cache** for caching auth tokens. In cloud, runs in Azure App Services (wewalk-backend-v2). For cloud database, it uses MongoDB inside Azure Cosmos DB. For passwordless authentication, Firebase Authentication is used, other than that, users can use email-password sign-in as well. Transportation services are fed by [Azure Maps Mobility Services](https://docs.microsoft.com/en-us/rest/api/maps/mobility) [RAW JSON](/api/v2/documentation) - [Swagger Editor](https://editor.swagger.io) <br><br> Production Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI'/> <br><br>Test Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI-staging'/>
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CheckDeviceRequest } from '../models';
import { CheckDeviceResponse } from '../models';
import { ErrorModelResponse } from '../models';
/**
 * DeviceApi - axios parameter creator
 * @export
 */
export const DeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if the device should be updated or not by its serial number
         * @param {CheckDeviceRequest} body Check if the device should be updated or not by its serial number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceCheckSerialNumberPost: async (body: CheckDeviceRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling deviceCheckSerialNumberPost.');
            }
            const localVarPath = `/device/checkSerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the Vestel device serial numbers to be updated from Azure Storage.
         * @param {number} [client] ui:0 - ios:1 - android:2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceGetSerialNumbersToBeUpdatedGet: async (client?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/device/getSerialNumbersToBeUpdated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            if (client !== undefined && client !== null) {
                localVarHeaderParameter['client'] = String(JSON.stringify(client));
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceApi - functional programming interface
 * @export
 */
export const DeviceApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if the device should be updated or not by its serial number
         * @param {CheckDeviceRequest} body Check if the device should be updated or not by its serial number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceCheckSerialNumberPost(body: CheckDeviceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckDeviceResponse>> {
            const localVarAxiosArgs = await DeviceApiAxiosParamCreator(configuration).deviceCheckSerialNumberPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets the Vestel device serial numbers to be updated from Azure Storage.
         * @param {number} [client] ui:0 - ios:1 - android:2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deviceGetSerialNumbersToBeUpdatedGet(client?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await DeviceApiAxiosParamCreator(configuration).deviceGetSerialNumbersToBeUpdatedGet(client, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * DeviceApi - factory interface
 * @export
 */
export const DeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Check if the device should be updated or not by its serial number
         * @param {CheckDeviceRequest} body Check if the device should be updated or not by its serial number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceCheckSerialNumberPost(body: CheckDeviceRequest, options?: any): AxiosPromise<CheckDeviceResponse> {
            return DeviceApiFp(configuration).deviceCheckSerialNumberPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the Vestel device serial numbers to be updated from Azure Storage.
         * @param {number} [client] ui:0 - ios:1 - android:2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deviceGetSerialNumbersToBeUpdatedGet(client?: number, options?: any): AxiosPromise<void> {
            return DeviceApiFp(configuration).deviceGetSerialNumbersToBeUpdatedGet(client, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
export class DeviceApi extends BaseAPI {
    /**
     * 
     * @summary Check if the device should be updated or not by its serial number
     * @param {CheckDeviceRequest} body Check if the device should be updated or not by its serial number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceCheckSerialNumberPost(body: CheckDeviceRequest, options?: any) {
        return DeviceApiFp(this.configuration).deviceCheckSerialNumberPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Gets the Vestel device serial numbers to be updated from Azure Storage.
     * @param {number} [client] ui:0 - ios:1 - android:2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public deviceGetSerialNumbersToBeUpdatedGet(client?: number, options?: any) {
        return DeviceApiFp(this.configuration).deviceGetSerialNumbersToBeUpdatedGet(client, options).then((request) => request(this.axios, this.basePath));
    }
}
